<script setup lang="ts"></script>

<template>
  <div class="ui-accordion flex flex-col bg-white rounded-2xl overflow-hidden divide-y divide-neutral-400 border border-neutral-400">
    <slot />
  </div>
</template>
